import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setCarregando(true);
    setErro('');

    try {
      // Em modo demonstrativo, apenas simula o envio
      console.log(`Simulando recuperação de senha para e-mail: ${email}`);
      
      // Aguarda 1 segundo para simular requisição
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setEnviado(true);
    } catch (error) {
      setErro('Ocorreu um erro ao processar sua solicitação. Tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="card">
          <div className="card-header text-center">
            <img src="/logo.png" alt="Logo" style={{ height: '60px', marginBottom: '10px' }} />
            <h1 className="h3">Recuperar Senha</h1>
          </div>
          <div className="card-body login-card-body">
            {!enviado ? (
              <>
                <p className="login-box-msg">Informe seu e-mail para receber instruções</p>
                
                {erro && (
                  <div className="alert alert-danger" role="alert">
                    {erro}
                  </div>
                )}
                
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <i className="fas fa-envelope"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-12">
                      <button 
                        type="submit" 
                        className="btn btn-primary btn-block"
                        disabled={carregando}
                      >
                        {carregando ? 'Enviando...' : 'Enviar instruções'}
                      </button>
                    </div>
                  </div>
                </form>
              </>
            ) : (
              <div className="text-center">
                <div className="alert alert-success">
                  Instruções enviadas para seu e-mail!
                </div>
                <p>Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.</p>
              </div>
            )}
            
            <p className="mt-3 mb-1">
              <Link to="/login">Voltar para login</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
